module.exports = __webpack_public_path__ + "img/22_68.8005abf9.png";